module.exports = __webpack_public_path__ + "img/hightlight-art-6-8.6d074bcc.png";